import React, { Fragment, useMemo } from "react";
import { NotificationId, SystemAdminNotification } from "src/globalTypes";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import { useSystemAdminNofificationsObject } from "src/store/notifications/systemAdmin/useSelectors";
import {
  createDataSourcesViewLink,
  createNotificationTemplatesViewLink,
} from "src/utils/internalLinksParsing";
import AdminCardList from "./AdminCardList";

type Props = {
  dismissNotification(id: NotificationId): void;
  onCardClickSideEffect(): void;
};

const SystemAdminCardList = ({
  dismissNotification,
  onCardClickSideEffect,
}: Props) => {
  const formatMsg = useFormatMsg();

  const { notifTemplateNotification, defaultMappingNotification } =
    useSystemAdminNofificationsObject();

  return (
    <Fragment>
      {notifTemplateNotification && (
        <AdminCardList
          key={notifTemplateNotification.notificationId}
          label={notifTemplateNotification.label}
          title={formatMsg("notifications.system.notification")}
          link={createNotificationTemplatesViewLink(
            notifTemplateNotification.dataIds
          )}
          handleClick={onCardClickSideEffect}
          handleDelete={() =>
            dismissNotification(notifTemplateNotification.notificationId)
          }
        />
      )}
      {defaultMappingNotification && (
        <AdminCardList
          key={defaultMappingNotification.notificationId}
          label={defaultMappingNotification.label}
          title={formatMsg("notifications.system.default_mapping")}
          link={createDataSourcesViewLink(defaultMappingNotification.dataIds)}
          handleClick={onCardClickSideEffect}
          handleDelete={() =>
            dismissNotification(defaultMappingNotification.notificationId)
          }
        />
      )}
    </Fragment>
  );
};

export default SystemAdminCardList;
